var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-brief"},[_c('feature-list',{staticClass:"mb-4",attrs:{"cart":_vm.cart}}),_c('addons',{staticClass:"mb-4",attrs:{"addons":_vm.cart.addons}}),_c('requirements')],1)}
var staticRenderFns = []

export { render, staticRenderFns }